










import { defineComponent } from '@nuxtjs/composition-api'
export default defineComponent({
  name: 'ModalBottomLayout',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {}
  },
})
